define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"dojo/dom-construct",
	"dijit/registry",
	"dijit/Tree",
	"csi/widget/CheckBox"
], function(array, declare, lang, domClass, domConstruct, registry, Tree, CheckBox) {

	return declare(dijit._TreeNode,
		{
			checkbox: null,
			_bPropagateDown: true,
			_bPropagateUp: true,

			getCheckboxValue: function() {
				// summary: return value of checkbox
				return this.checkbox ? !!this.checkbox.get("value") : true;
			},

			buildRendering: function() {
				// summary: add checkbox to tree node
				this.inherited(arguments);

				domClass.add(this.domNode, "checkboxTreeNode");

				var store = this.tree.model.store;
				if (store.isItem(this.item)) {
					var checkboxArgs = store.getValue(this.item, this.tree.CHECKBOX);
					if (checkboxArgs) {
						this.checkbox = new CheckBox(checkboxArgs, domConstruct.create("span", null, this.expandoNode, "after"));
						this.connect(this.checkbox, "onChange", "_onCheckboxChange");
						this.checkbox.startup();
						this.checkbox.set("value", store.getValue(this.item, this.tree.VALUE), false);
					}
				}
			},

			_onCheckboxChange: function(/*Any*/value) {
				// summary: notify listeners of checkbox event
				var tree = this.tree;

				// stop recursive loop when updating parent checkboxes
				if (this._bPropagateDown) {
					if (tree._bWriteStore) {
						// apply new value to all children through data store - it could be that tree nodes aren't created
						// for children yet
						var attrCheckbox = tree.CHECKBOX;
						var attrChecked = tree.VALUE;
						var model = tree.model;
						var store = model.store;
						var children = store.getValues(this.item, model.childrenAttrs[0]);

						store.setValue(this.item, attrChecked, value);

						array.forEach(children, function(item) {
							if ((store.getValue(item, attrChecked) != value) && !store.getValue(item, attrCheckbox).disabled) {
								// only call setValue if changing value - otherwise _bPropagateUp flag will not get reset
								// because _onCheckboxChange will not get called
								var node = tree.getNodesByItem(item)[0];
								if (node) node._bPropagateUp = false;
								store.setValue(item, attrChecked, value);
							}
						}, this);
					} else {
						// apply new value to all children explicitly
						value = this.checkbox.get("value");

						array.forEach(this.getChildren(), function(node) {
							if (node.checkbox && !node.checkbox.get("disabled")) {
								node._bPropagateUp = false;
								node.checkbox.set("value", value);
							}
						});
					}
				} else {
					this._bPropagateDown = true;
				}

				// update checkbox value of parents based on children values
				if (this._bPropagateUp) {
					var p = this;

					while (p = p.getParent()) {
						if (p._updateCheckbox) {
							p._updateCheckbox(value);
						} else {
							break;
						}
					}
				} else {
					this._bPropagateUp = true;
				}

				tree.onTreeChecked(tree);
			},

			_updateCheckbox: function(/*Boolean*/value) {
				// summary: update checkbox of only this node based on child values
				var cb = this.checkbox;
				if (cb) {
					// if current value is same as changed child value, then nothing to worry about
					var bCurrent = this.getCheckboxValue();
					if (bCurrent == value) return;

					var bOn = !!array.some(this.getChildren(), function(tn) {return tn.getCheckboxValue();});
					if (bOn != bCurrent) {
						this._bPropagateDown = false;

						if (this.tree._bWriteStore) {
							this.tree.model.store.setValue(this.item, this.tree.VALUE, bOn);
						} else {
							cb.set("value", bOn);
						}
					}
				}
			}
		}
	);
});